import React from 'react'

const DuplicateIcon = () => (
  <>
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.75 12.75H3.15C1.82 12.75 0.75 11.68 0.75 10.35V3.15C0.75 1.82 1.82 0.75 3.15 0.75H10.35C11.68 0.75 12.75 1.82 12.75 3.15V3.75M9.15 6.75H16.35C16.9865 6.75 17.597 7.00286 18.0471 7.45294C18.4971 7.90303 18.75 8.51348 18.75 9.15V16.35C18.75 16.9865 18.4971 17.597 18.0471 18.0471C17.597 18.4971 16.9865 18.75 16.35 18.75H9.15C8.51348 18.75 7.90303 18.4971 7.45294 18.0471C7.00286 17.597 6.75 16.9865 6.75 16.35V9.15C6.75 8.83483 6.81208 8.52274 6.93269 8.23156C7.0533 7.94038 7.23008 7.6758 7.45294 7.45294C7.6758 7.23008 7.94038 7.0533 8.23156 6.93269C8.52274 6.81208 8.83483 6.75 9.15 6.75Z'
        stroke='black'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </>
)

export default DuplicateIcon
